// takes a string and returns it with dashes instead of spaces and in lower case.
// util when transforming a string to a translation key
export const dashify = (str: string) =>
  str?.trim().toLowerCase().replace(/\s/g, '-')
